
export class ApiClient {
    private readonly baseURL: string;
    private token: string | null = null;

    constructor(baseURL: string) {
        this.baseURL = baseURL;
    }

    setToken(token: string) {
        this.token = token;
    }

    clearToken() {
        this.token = null;
    }

    private async request(endpoint: string, method: string, body: object | null = null, customHeaders: HeadersInit = {}): Promise<Response> {
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            ...customHeaders,
        };

        if (this.token) {
            (headers as Record<string, string>)['Authorization'] = `Bearer ${this.token}`;
        }

        return fetch(`${this.baseURL}${endpoint}`, {
            method, headers,
            body: body ? JSON.stringify(body) : null
        });
    }

    async get<T>(endpoint: string, params?: Record<string, any>, customHeaders?: HeadersInit): Promise<T> {
        const url = new URL(endpoint, this.baseURL); // Properly handle concatenation
        if (params) {
            Object.entries(params).forEach(([key, value]) => {
                url.searchParams.append(key, value as string);
            });
        }

        const response = await this.request(endpoint, 'GET', null, customHeaders);
        return await response.json() as T;
    }

    async post<T>(endpoint: string, body: object, customHeaders?: HeadersInit): Promise<T> {
        const response = await this.request(endpoint, 'POST', body, customHeaders);
        return await response.json() as T;
    }

    async put<T>(endpoint: string, body: object, customHeaders?: HeadersInit): Promise<T> {
        const response = await this.request(endpoint, 'PUT', body, customHeaders);
        return await response.json() as T;
    }


    async delete<T>(endpoint: string, customHeaders?: HeadersInit): Promise<T> {
        const response = await this.request(endpoint, 'DELETE', null, customHeaders);
        return await response.json() as T;
    }

}